import * as React from 'react';

import styles from './modal-subheader.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

ModalSubheader.defaultProps = {
    as: 'p',
};

export function ModalSubheader({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles['modal-subheader']}>{children}</Tag>;
}
